/// <reference path="../../Scripts/MarkerClusterer/markerClusterer.d.ts"/>

module Bookhus {
    export class Searchwidget {

        private container: JQuery;
        private mapContainer: JQuery;
        private searchContainer: JQuery;
        private searchButton: JQuery;

        private map: google.maps.Map;
        private overlay: google.maps.OverlayView;
        private dataService: SearchwidgetDataservice;

        private markers: any = [];
        private locationId: any;
        private filterTimer: any;

        private settings: any;

        private cluster: MarkerClusterer;

        private static BOOKHUS_GREY_PIN: string = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
        private static BOOKHUS_RED_PIN: string = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
        private static BOOKHUS_RED_OUTLINE_PIN: string = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';

        constructor(settings: { containerSelector?: string, disableSearch?: boolean, autoOpen?: boolean, useMarkerCluster?: boolean, options?: any }) {
            var self = this;


            var options = { zoom: 6, maxFitZoom: 10, mapType: false, mapTypePosition: "TOP_CENTER", mapTypeStyle: "DROPDOWN_MENU", ...settings.options }
            settings = { containerSelector: "", disableSearch: false, autoOpen: false, useMarkerCluster: false, ...settings, options: options };



            self.settings = settings;
            self.container = $(self.settings.containerSelector);

            self.setContainers();
            self.dataService = new SearchwidgetDataservice();
        }

        private getSearchWidgetLanguage(): any {
            var bookhus = (window as any).Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI
                && bookhus.Localization.Standard.UI.Widgets) {
                return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
            }
            return null;
        }

        private translate(name: string): string {
            var searchWidgetLanguage = this.getSearchWidgetLanguage();
            if (!searchWidgetLanguage) {
                return "";
            }

            switch (name) {
                case "HavDistance":
                    return searchWidgetLanguage.HavDistance || searchWidgetLanguage.Hav || "";
                case "KøbmandDistance":
                    return searchWidgetLanguage.KøbmandDistance || searchWidgetLanguage.Købmand || "";
                case "MaxPrice":
                    return searchWidgetLanguage.MaxPrice || searchWidgetLanguage["Maks pris"] || "";
                default:
                    return searchWidgetLanguage[name] || "";
            }
        }

        public init(): void {
            var self = this;
            if (self.mapContainer === null || self.mapContainer === undefined) {
                return;
            }

            if (self.mapContainer.length === 0) {
                return;
            }

            //container[0] er selve dom elementet 
            var map = new google.maps.Map(self.mapContainer[0], {
                disableDefaultUI: true,
                center: { lat: 55.814666, lng: 10.588629 },
                zoom: self.settings.options.zoom,
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                scaleControl: false,
                rotateControl: false,
                mapTypeControl: self.settings.options.mapType,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle[self.settings.options.mapTypeStyle],
                    position: google.maps.ControlPosition[self.settings.options.mapTypePosition]
                }
            } as any);
            self.container.css('backgroundImage', 'none');

            self.map = map;

            var overlay = new google.maps.OverlayView();
            overlay.draw = function () { };
            overlay.onAdd = function () {
                //var projection = this.getProjection();
                //var pixel = projection.fromLatLngToContainerPixel(marker.getPosition());
                //console.log(pixel);
            };
            overlay.setMap(map);
            self.overlay = overlay;

            //Get data
            self.loadData();
            if (!self.settings.disableSearch) {
                $.when(self.dataService.loadControlSettings(), self.dataService.loadLocations()).done(() => {
                    self.renderFilters();
                    self.initializeMaps();
                });
            }

            if (self.settings.useMarkerCluster) {
                self.cluster = new MarkerClusterer(self.map, []);
                self.cluster.setAverageCenter(true);
            }

        }

        private setContainers(): void {
            var self = this;
            if (!self.settings.disableSearch) {
                self.container.html(`
<div class="search-filter-box"><span class="fa fa-search" aria-hidden="true"></span><span style="font-size: 0.5em;">Søg</span></div>
<div class="google-search-map"></div>
<div class="google-search-filter brand-background-transparent"></div>
`);
                self.mapContainer = self.container.find('.google-search-map');
                self.searchContainer = self.container.find('.google-search-filter');
                self.searchButton = self.container.find('.search-filter-box');
            }
            else {
                self.container.html(`<div class="google-search-map"></div>`);
                self.mapContainer = self.container.find('.google-search-map');
            }
        }

        private toggleFilterTimer(element) {
            var self = this;
            var lastFilterElem;
            self.filterTimer = setInterval(() => {
                var filter = $(element);
                var selected = filter.children('option:selected');
                if (lastFilterElem && lastFilterElem[0] != selected[0]) {
                    clearInterval(self.filterTimer);
                    return;
                }
                var nextElem;
                if (filter.children('option:last')[0] != selected[0]) {
                    nextElem = selected.next('option');
                }
                else {
                    nextElem = filter.children('option:first');
                }
                filter.val(nextElem.val());
                lastFilterElem = nextElem;
                filter.trigger('change');
            }, 1000 * 10);
        }

        private renderFilters(): void {
            var self = this;

            var controls = "";
            if (self.dataService.controlSettings.showPeriod) {
                var weeks = `<option value="0">1 ${self.translate("Dag")}</option>`;
                for (var i = 1; i < (self.dataService.controlSettings.maxPeriodDays || 28); i++) {
                    var tekst = "";
                    if ((i + 1) % 7 == 0) {
                        var week = (i + 1) / 7;
                        if (week == 1) {
                            tekst = week + " " + self.translate("Uge");
                        }
                        else {
                            tekst = week + " " + self.translate("Uger");
                        }
                    }
                    else {
                        tekst = (i + 1) + " " + self.translate("Dage");
                    }
                    weeks += `<option ${i == 6 ? "selected" : ""} value="${i}">${tekst}</option>`;
                }

                controls += `
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>${self.translate("Periode")}</label>
                            <div class="row">
                                <div class="col-md-6">
                                    <input type="text" id="startDate" name="arrivalDate" placeholder="${self.translate("StartDato")}" class="datePicker form-control"/>
                                </div>
                                <div class="col-md-6">
                                    <select class="form-control" id="periodWeeks" name="days">
                                        ${weeks}
                                    </select>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }

            if (self.dataService.controlSettings.showRooms) {
                var rooms = "";
                for (var i = 2; i <= (self.dataService.controlSettings.maxRooms || 4); i++) {
                    rooms += `<option value="${i}">${i} ${self.translate("Værelser")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("Værelser")}</label>
                            <select class="form-control" name="roomcount">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Værelse")}</option>
                                ${rooms}
                            </select>
                        </div>            
                    </div>
                `;
            }

            if (self.dataService.controlSettings.showPersons) {
                var persons = "";
                for (var i = 2; i <= (self.dataService.controlSettings.maxPersons || 8); i++) {
                    persons += `<option value="${i}">${i} ${self.translate("Personer")}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("AntalPersoner")}</label>
                            <select class="form-control" name="personcount">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                <option value="1">1 ${self.translate("Person")}</option>
                                ${persons}
                            </select>
                        </div>
                    </div>
                `;
            }

            if (self.dataService.controlSettings.showDistanceToSea) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("HavDistance")}</label>
                            <select class="form-control" name="havDistance">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }

            if (self.dataService.controlSettings.showDistanceToGrocer) {
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("KøbmandDistance")}</label>
                            <select class="form-control" name="købmandDistance">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
            }

            if (self.dataService.controlSettings.showArea) {
                var locationData = self.dataService.locations || [];
                var locations = "";
                for (var i = 0; i < locationData.length; i++) {
                    locations += `<option value="${locationData[i].id}">${locationData[i].name}</option>`;
                }
                controls += `
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>${self.translate("Område")}</label>
                            <select class="form-control" id="locations" name="lokation">
                                <option value="0">${self.translate("IkkeValgt")}</option>
                                ${locations}
                            </select>
                        </div>
                    </div>
                `;
            }



            var facilities = "";
            var filters = self.dataService.controlSettings.facilities || [];
            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                facilities += `
                    <div class="col-md-4">
                        <span class="${self.dataService.GetCssIcon(filter)} brand-background" style="height: 27px; width: 27px; font-size: 1.75em; margin-right: 5px;"></span>
                        <label style="position: absolute; font-weight: normal; margin-bottom: 0;">
                        <input type="checkbox"  name="${SearchFilterType[filter]}"/> ${self.translate(SearchFilterType[filter])}</label>    
                    </div>
                `;
            }

            var html = "";

            html = `
<div>
    <div class="row">
        <div class="col-md-12">
            <h4 style="color:white; display: inline;">${self.translate("Søg")}</h4>
        </div>
    </div>
    <div class="row">
        ${controls}
    </div>    
    <div class="row">
        <div class="col-md-12"><label>${self.translate("Faciliteter")}</label></div>
        ${facilities}
    </div>
</div>
<span class="btnGroup pull-right">
    <button type="button" data-command="resetFilters">${self.translate("Nulstil")}</button>                    
    <button type="button" data-command="showInCatalog">${self.translate("VisKatalog")}</button>
</span>
`;


            self.searchContainer.html(html);
            if (self.settings.autoOpen) {
                self.searchContainer.addClass('open');
            }
        }

        private initializeMaps() {
            var self = this;

            self.map.addListener('tilesloaded', () => {
                $('.google-search-filter').css('display', 'block');
            });

            $(".search-filter-box").on("click", (e) => {
                $('.google-search-filter').toggleClass('open');
                clearInterval(self.filterTimer);
            });

            //Fullscreen button
            self.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.createElement('div'));
            //FullScreenControl(self.map, "Gør større", "Gør mindre"));

            //Dropdown filter menu
            var locationSelector = document.createElement('select');
            locationSelector.className = "googlestyle-dropdown";
            var temp = document.createElement('option');
            temp.value = "0";
            temp.innerText = "Alle steder";
            locationSelector.appendChild(temp);
            var locationData = self.dataService.locations;
            for (var i = 0; i < locationData.length; i++) {
                var option = document.createElement('option');
                option.value = locationData[i].id.toString();
                option.innerText = locationData[i].name;
                locationSelector.appendChild(option);
            }
            $(locationSelector).on('change', (e) => {
                $('#locations').val($(e.target).val());
                $('#locations').change();
            });
            self.map.controls[google.maps.ControlPosition["TOP_LEFT"]].push(locationSelector);
            //self.toggleFilterTimer(locationSelector);


            $('.google-search-filter input, .google-search-filter select').on('change', (e) => {
                var current = $(e.target);
                if (current.attr('name') === 'lokation') {
                    $(locationSelector).val(current.val());
                }
                if (current.is(':checked') && (current.attr('name') === 'Husdyr' || current.attr('name') === 'HusdyrIkkeTilladt')) {
                    var oppositeName = current.attr('name') === 'Husdyr' ? 'HusdyrIkkeTilladt' : 'Husdyr';
                    self.searchContainer.find(`input[name="${oppositeName}"]`).prop('checked', false);
                }
                self.loadFilteredData();
            });

            $('.google-search-filter :text').on('keyup', () => {
                self.debounce(self.loadFilteredData(), 100);
            });

            $('[data-command="resetFilters"]').on('click', (e) => {

                $(self.searchContainer.find('input, select, textarea')).each((index, element) => {
                    var current = $(element);

                    if (current.prop('type') == "checkbox") {
                        current.prop('checked', false);
                        return;
                    }
                    if (current.attr('name') == "days") {
                        current.val('6');
                        return;
                    }

                    if (current.attr('name') == "købmandDistance" || current.attr('name') == "havDistance") {
                        current.val('-1');
                        return;
                    }


                    if (current.prop('nodeName') == "INPUT" || current.prop('nodeName') == "TEXTAREA") {
                        current.val('');
                        return;
                    }
                    if (current.prop('nodeName') == "SELECT") {
                        current.val('0');
                        return;
                    }


                });

                self.loadData();
            });

            $('[data-command="showInCatalog"]').on('click', () => {

                var params = [] as string[];
                var hasActiveFilter = false;

                $(self.searchContainer.find('input[name], select[name], textarea[name]')).each((index, element) => {
                    var current = $(element);

                    var value;
                    if (current.prop('type') == "checkbox") {
                        value = current.is(':checked');
                    }
                    else {
                        value = current.val();
                    }

                    var name = current.attr('name');
                    hasActiveFilter = hasActiveFilter || self.isCatalogFilterActive(name, value);
                    params.push(encodeURIComponent(name) + "=" + encodeURIComponent(value == null ? "" : value.toString()));
                });

                var houseIds = self.getCurrentHouseIds();
                if (hasActiveFilter && houseIds) {
                    params.push("houseIds=" + encodeURIComponent(houseIds));
                }

                params.push("bypassCache=true");

                window.location.href = "/catalog?" + params.join("&");
            });

            BindCalendars();

        }

        private isCatalogFilterActive(name: string, value: any): boolean {
            if (value == null || value === "" || value === false || value === "false") {
                return false;
            }

            if (name === "days") {
                return false;
            }

            if (name === "roomcount" || name === "personcount" || name === "lokation") {
                return parseInt(value, 10) > 0;
            }

            if (name === "havDistance" || name === "købmandDistance") {
                return parseInt(value, 10) > -1;
            }

            return true;
        }

        private getCurrentHouseIds(): string {
            var houseIds = [] as number[];

            if (!this.dataService || !this.dataService.markers) {
                return "";
            }

            this.dataService.markers.forEach((marker) => {
                if (marker.type !== MarkerType.house || houseIds.indexOf(marker.id) > -1) {
                    return;
                }

                houseIds.push(marker.id);
            });

            return houseIds.join(",");
        }

        private loadData() {
            var self = this;
            var xhr = this.dataService.loadDataAjax();
            xhr.always(() => {
                this.clearMap();
                if (self.settings.useMarkerCluster) {
                    this.updateMapClusterer();
                }
                else {
                    this.updateMap();
                }
                this.fitBounds();
            });
        }

        private updateMap() {
            var self = this;
            // sæt markører ind..
            // de ligger i this.dataService.houses            
            this.dataService.markers.forEach((element) => {
                var marker = new google.maps.Marker({
                    position: element.position as any,
                    icon: {
                        url: Searchwidget.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    map: this.map,
                    title: element.title,
                    markerId: 0,
                    markerType: null
                });


                var content = `<span id="infowindow_${element.type}_${element.id}"></span>${element.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });


                marker.addListener("click", () => {
                    var self = this;
                    infowindow.open(self.map, marker);
                });

                google.maps.event.addListener(infowindow, 'domready', function () {
                    var img = $("#iw-container-" + element.id + " img");
                    var url = img.data("src") as any;
                    img.attr("src", url);
                    var projection = self.overlay.getProjection();

                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(marker.getPosition());
                    var container = $(`#infowindow_${element.type}_${element.id}`).parents('.gm-style-iw.gm-style-iw-c:first');

                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;

                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);

                    self.map.panTo(position);
                });

                this.markers.push(marker);
            });
        }

        private updateMapClusterer() {
            var self = this;
            self.cluster.clearMarkers();

            // sæt markører ind..
            // de ligger i this.dataService.houses            
            this.dataService.markers.forEach((element) => {
                var marker = new google.maps.Marker({
                    position: element.position as any,
                    icon: {
                        url: Searchwidget.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    //map: this.map,
                    title: element.title,
                    markerId: 0,
                    markerType: null
                });


                var content = `<span id="infowindow_${element.type}_${element.id}"></span>${element.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });


                marker.addListener("click", () => {
                    var self = this;
                    infowindow.open(self.map, marker);

                    var img = $("#iw-container-" + element.id + " img");
                    var url = img.data("src") as any;
                    img.attr("src", url);
                    clearInterval(self.filterTimer);
                });

                google.maps.event.addListener(infowindow, 'domready', function () {
                    var projection = self.overlay.getProjection();

                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(marker.getPosition());
                    var container = $(`#infowindow_${element.type}_${element.id}`).parents('.gm-style-iw:first').parent();

                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;

                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);

                    self.map.panTo(position);
                });

                this.markers.push(marker);
            });
            self.cluster.addMarkers(self.markers, false);
        }

        private clearMap() {
            this.markers.forEach((element) => {
                element.setMap(null);
            });
            this.markers = [];
        }

        private loadFilteredData() {
            var self = this;
            var filters = {} as ISearchCridentials;

            $(self.searchContainer.find('input, select, textarea')).each((index, element) => {
                var current = $(element);
                if (current.prop('type') == "checkbox") {
                    filters[current.attr('name')] = current.is(':checked');
                }
                else {
                    filters[current.attr('name')] = current.val();
                }
            });

            if (filters.arrivalDate.length < 10 && filters.arrivalDate.length > 0) {
                return;
            }
            var xhr = this.dataService.searchData(filters);
            if (xhr) {
                xhr.always(() => {
                    this.clearMap();
                    if (this.dataService.markers.length > 0) {
                        if (self.settings.useMarkerCluster) {
                            this.updateMapClusterer();
                        }
                        else {
                            this.updateMap();
                        }
                        this.fitBounds();
                    }
                });
            }
        }

        private fitBounds() {
            var self = this;

            if (this.markers && this.markers.length > 0) {
                var bounds = new google.maps.LatLngBounds();
                this.markers.forEach((element, index) => {
                    bounds.extend(this.markers[index].getPosition());
                });
                this.map.fitBounds(bounds);
                if (this.map.getZoom() > self.settings.options.maxFitZoom) {
                    this.map.setZoom(self.settings.options.maxFitZoom);
                }
                return;
            }

            this.map.setCenter({ lat: 55.814666, lng: 10.588629 });
            this.map.setZoom(self.settings.options.zoom);
            return;
        }

        private debounce(fn, delay) {
            var timeoutId;
            return function debounced() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                var args = arguments;
                timeoutId = setTimeout(() => { fn.apply(this, args); }, delay);
            }
        }
    }
}
